import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { specificMarketColumns } from "../../../../config/TableColumns.config";
import TableProgress from "../../../General/TableProgress"
import ReportsServices from "../../../../services/Reports.services";
import { setSelectedGeneralMarketCategory, setSelectedGeneralMarketCategoryIsLoading } from "../../../../store/components/Reports.slice";
import { specificMarketColors } from "../../../../config/Colors.config";
import CustomLayout from "../../../General/CustomLayout/CustomLayout";
import TreemapChart from "@ant-design/plots/es/components/treemap";
import TreeMapSkeleton from "../../../General/skeleton/TreeMapSkeleton"
import TableSkeleton from "../../../General/skeleton//TableSkeleton"
import CustomTable from "../../../../customcomponents/customtable/CustomTable";
import GeneralMarketCategoriesModal from "./GeneralMarketCategoriesModal";
import { generateGUID } from "../../../../utils/MainHelper";
import TrackFeatureServices from "../../../../services/TrackFeature.services";

const columns = specificMarketColumns.map((col) => {
    if (col.key === "score") {
        return {
            ...col,
            render: (value, row) => (
                <TableProgress
                    value={value}
                    color={row.color}
                />
            )
        };
    }
    return col;
});

function GeneralMarketCategories({
    data = [],
    loading = true
}) {
    const dispatch = useDispatch();
    const [visibleModal, setvisibleModal] = useState(false);
    const {
        countryNotAvailable
    } = useSelector((state) => state.buildTargets);

    const onClickTile = (args) => {
        if (countryNotAvailable) return;
        const tileData = args[0]?.data?.data?.data;
        const groupObj = {
            discoveredCategory: tileData.name,
            group: 1,
            targetAudience: ReportsServices.getMastersTargetAudience(),
            children: [],
            key: `${generateGUID()}~~deepDiveItem`,
            loadingSelectedTile: true
        };
        dispatch(setSelectedGeneralMarketCategoryIsLoading(true));
        dispatch(setSelectedGeneralMarketCategory(groupObj));
        const { commonParams } = TrackFeatureServices.getMonitor({ featureKey: "advanceFullMarketTile" })
        const { promise } = ReportsServices.getSubjectsDeepDive(tileData.name, () => { }, commonParams);
        promise.then((response) => {
            if (response.length) {
                dispatch(setSelectedGeneralMarketCategory({
                    ...response[0],
                    loadingSelectedTile: groupObj.loadingSelectedTile,
                    discoveredCategory: groupObj.discoveredCategory
                }));
            }
            dispatch(setSelectedGeneralMarketCategoryIsLoading(false));
        });
        setvisibleModal(true);
    };
    const NewData = data.map((item, idx) => ({
        ...item,
        color: specificMarketColors[idx],
        value: (item.score * 100).toFixed(2),
        name: item.item
    }));
    const header = (
        <div className="d-flex-col" style={{ width: "100%" }}>
            <b className="report--title">Top Categories</b>
            <p className="report--subtitle">Here are the most engaged behavioral categories based on your input</p>
        </div>
    );
    return (
        <CustomLayout
            className="report--generalmarketcategories"
            classNameHeader="report--generalmarketcategories--header"
            classNameBody="report--generalmarketcategories--body flex-1 gap-1"
            style={{ width: "100%", height: "100%" }}
            header={header}
        >
            <div className="report--panel" style={{ width: "60%" }}>
                {!loading ? <TreemapChart onClickTile={onClickTile} customColor data={NewData} /> : <TreeMapSkeleton />}
            </div>
            <div className="report--panel" style={{ width: "40%" }}>
                {!loading ? (
                    <CustomTable
                        style={{ height: "100%" }}
                        noCheckbox
                        pagination={false}
                        columns={columns}
                        dataSource={NewData}
                        numColProps={{ width: "40px" }}
                    />
                ) : <TableSkeleton />}
            </div>

            {visibleModal && <GeneralMarketCategoriesModal visible={visibleModal} setIsVisible={setvisibleModal} />}
        </CustomLayout>
    );
}

export default GeneralMarketCategories;
